<template>
    <div ref="PageContainer2" class="page-container2" @scroll="handleScroll">
        <div slot="header" :class="'header ' + (scrollTop>0 ? 'header-float' : '')" :style="'top: ' + scrollTop + 'px;'">
            <div class="header-blank"></div>
            <div style="flex: 1; display: flex; flex-direction: row; justify-content:  space-between;">
                <el-page-header @back="close" :content="title" v-if="showPageBack">
                </el-page-header>
                <div class="el-page-header__content" v-else>{{ title }}</div>
                <div>
                    <slot name="buttons"></slot>
                    <el-button type="success" size="mini" @click="handleRefresh" v-if="showRefreshButton||showRefreshBtn">刷新</el-button>
                    <el-button type="info" size="mini" @click="close" v-if="showCloseButton">关闭</el-button>
                </div>
            </div>
            <div class="header-blank"></div>
        </div>
        <component :is="tag"
                   :shadow="useCard ? 'always' : 'never'"
                   :class="'box-card ' + (useCard ? 'card-form' : 'without-card') " style="margin-top: 60px; margin-bottom: 20px;">
            <slot ></slot>
        </component>
    </div>
</template>

<script>
    export default {
        name: "PageContainer2",
        props: {
            title: String,
            useCard: Boolean,
            showRefreshButton: {
                type: Boolean,
                default: false
            },
            showPageBack: {
                type: Boolean,
                default: false,
            },
            showRefreshBtn: {
                type: Boolean,
                default: false
            },
            showCloseButton: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                scrollTop: 0,
                tag: this.useCard ? 'el-card' : 'div',
            }
        },
        activated() {
            console.info("PageContainer2 activated", this.$refs.PageContainer2.scrollTop);
            this.$refs.PageContainer2.scrollTop = this.scrollTop;
            this.scrollTop = this.$refs.PageContainer2.scrollTop;
        },
        deactivated() {
            console.info("PageContainer2 deactivated", this.$refs.PageContainer2.scrollTop);
            this.scrollTop = this.$refs.PageContainer2.scrollTop;
        },
        methods: {
            handleScroll(e) {
                // console.log("handleScroll", e);
                // this.$emit("pageScroll", e);
                this.scrollTop = e.target.scrollTop;
            },
            handleRefresh(e) {
                this.$emit("refresh", e);
            },
            close()
            {
                // this.$router.back();
                this.$store.dispatch('layout/routeBack');
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/common.scss";
    .page-container2
    {
        position: relative;
        width: 100%;
        height: 100%;
        /*padding: 0 20px;*/
        display: flex;
        box-sizing: border-box;
        background: $body-color;
        flex-direction: column;
        overflow: auto;
    }
    .form-container
    {
        width: 100%;
        position: relative;

    }
    .box-card {
        padding: 0 20px;
    }
    .card-form {
        // border: 1px solid $border-color;
        background-color: white;
        margin: 0 20px;
        padding: 20px 0;
    }
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        z-index: 999;
        width: 100%;
        padding: 15px 0;
        background: #f4f4f4;

    }
    .header-float {
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
    }
    .header-blank {
        width: 20px
    }
    .without-card .header{
        margin-bottom: 10px;
    }
    .header-title {
        font-size: 16px;
        font-weight: bold;
    }
    .el-card, .el-message {
        overflow: initial;
    }
</style>



// WEBPACK FOOTER //
// src/components/container/PageContainer2.vue